// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"CustomToggle_toggleWrapper__K0PfG","label":"CustomToggle_label__KTzoB","switch":"CustomToggle_switch__Gl9qm","slider":"CustomToggle_slider__86BNc"};